import { render, staticRenderFns } from "./SceneLib.vue?vue&type=template&id=fefd2a6a&scoped=true"
import script from "./SceneLib.vue?vue&type=script&lang=js"
export * from "./SceneLib.vue?vue&type=script&lang=js"
import style0 from "./SceneLib.vue?vue&type=style&index=0&id=fefd2a6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fefd2a6a",
  null
  
)

export default component.exports